'use strict';

angular.module('mobile-apps').controller('AddJiraIssueModalController', [
    '$rootScope',
    '$scope',
    'ModalData',
    'EntryMain',
    'MobileApps',
    'JiraApi',
    'Utilities',
    '$modalInstance',
    '$window',
    '$http',
    '$q',
    function (
        $rootScope,
        $scope,
        ModalData,
        EntryMain,
        MobileApps,
        JiraApi,
        Utilities,
        $modalInstance,
        $window,
        $http,
        $q
    ) {

        $scope.data = {
            title: undefined,
            description: undefined,
            issueTypeId: ModalData.jiraConfig.defaultIssueTypeId,
			reporterId: undefined
        };

        $scope.issueTypes = undefined;
        $scope.reporters = undefined;

        $scope.init = function() {
            var sendData = {
                host: ModalData.jiraConfig.host,
                email: ModalData.jiraConfig.email,
                apiToken: ModalData.jiraConfig.apiToken
            };

            JiraApi.users({ mobileAppId: ModalData.mobileApp._id }).$promise
                .then(
                    function (users) {
                        $scope.reporters = users;

                        JiraApi.issueTypes(sendData).$promise
                            .then(
                                function(data) {
                                    $scope.issueTypes = data.filter(function (issueType) {
                                        return ['Task', 'Bug', 'Story'].includes(issueType.name);
                                    });
                                }
                            )
                            .catch(
                                function (error) {
                                    Utilities.showMessageErrorResponse(error);
                                }
                            );
                    }
                )
                .catch(
                    function (error) {
                        Utilities.showMessageErrorResponse(error);
                    }
                );

        };


        $scope.addIssue = function() {
            var addIssueData = {
                mobileAppId: ModalData.mobileApp._id,
                summary: $scope.data.summary,
                description: $scope.data.description,
                issueTypeId: $scope.data.issueTypeId,
                entryKeys: ModalData.selectedEntryKeys,
				reporterId: $scope.data.reporterId
            };

            JiraApi.addIssue(addIssueData).$promise
                .then(
                    function(response) {
                        var url = window.location.href;
                        url += '/tag/' + response.tag._id;
                        var urlHref = '<a href="' + url + '">' + response.jiraIssue + '</a>';
                        var jiraFormattedUrl = '[here|' + url + ']';
                        var successMessage = 'Created new jira issue:' + urlHref;

                        var editIssueData = {
                            issueKey: response.jiraIssue,
                            mobileAppId: ModalData.mobileApp._id,
                            notifyUsers: false,
                            description: ($scope.data.description || '') + '\n' + 'Please see affected strings ' + jiraFormattedUrl
                        };

                        JiraApi.editIssue(editIssueData).$promise
                            .then(
                                function (updatedIssue) {
                                    Utilities.showMessage('Success', successMessage, 'success');
                                    $rootScope.$broadcast('addedJiraTag', { tag: response.tag, entryDescIds: ModalData.selectedEntryDescIds });
                                    $rootScope.$broadcast('tagsChanged');

                                    $modalInstance.close({
                                        success: true,
                                        data: response
                                    });
                                }
                            )
                            .catch(
                                function (error) {
                                    Utilities.showMessageErrorResponse(error);
                                }
                            );


                    }
                )
                .catch(
                    function(error) {
                        Utilities.showMessageErrorResponse(error);
                    }
                );
        };

        /**
         * Close modal
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        //init
        $scope.init();
    }
]);
